// DEV NOTE: Clean up footer link to "Your privacy choices" page
// Keeps icon after text and removes stray characters
document.addEventListener("DOMContentLoaded", function() {
    var privacyLink = document.querySelector('.footer-menu__link[href*="/pages/data-sharing-opt-out"]');
    if (privacyLink) {
        var icon = privacyLink.querySelector('img'); // grab the icon
        privacyLink.innerHTML = 'Your privacy choices'; // set clean text
        if (icon) {
            privacyLink.appendChild(icon); // put icon after the text
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
    var privacyLink = document.querySelector('.footer-menu__link[href*="/pages/data-sharing-opt-out"]');

    if (privacyLink) {
        privacyLink.childNodes.forEach(function(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                if (node.textContent.trim() === '>' || node.textContent.trim() === '"' || node.textContent.trim() === '">') {
                    node.remove();
                }
            }
        });

        // Make the link visible after cleanup
        privacyLink.style.visibility = 'visible';
    }
});